import { jsx } from 'react/jsx-runtime';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import * as React from 'react';
import styles from '../styles/uitk-egds-spacing.css';

const EGDSSpacingBorderMap = [
    ['blockstart', 'block-start'],
    ['blockend', 'block-end'],
    ['inlinestart', 'inline-start'],
    ['inlineend', 'inline-end'],
    ['unset', 'unset'],
];
const EGDSSpacingBorders = new Map(EGDSSpacingBorderMap);
const EGDSSpacingSpaceMap = [
    ['half', 'gap-half'],
    ['one', 'gap-one'],
    ['two', 'gap-two'],
    ['three', 'gap-three'],
    ['four', 'gap-four'],
    ['six', 'gap-six'],
    ['eight', 'gap-eight'],
    ['twelve', 'gap-twelve'],
    ['sixteen', 'gap-sixteen'],
];
const EGDSSpacingSpaces = new Map(EGDSSpacingSpaceMap);

const getClassNameList$1 = classNames.bind(styles);
const EGDSSpacing = (props) => {
    const { border, children, className, margin, padding, stid, style } = props;
    const childrenArray = React.Children.toArray(children);
    const firstChild = childrenArray[0];
    if (!firstChild || typeof firstChild !== 'object' || !('props' in firstChild)) {
        return null;
    }
    const firstChildClassName = firstChild.props.className;
    const firstChildStyle = firstChild.props.style;
    const makeRecursiveClass = (obj, propName, classPrefix, nonen = false) => {
        const arr = [];
        const objIsArray = Array.isArray(obj);
        Object.getOwnPropertyNames(obj).forEach((val) => {
            if (typeof obj[val] === 'object' && obj[val] !== null) {
                arr.push(makeRecursiveClass(obj[val], propName, classPrefix, val));
            }
            else {
                const classArr = [classPrefix, propName, ...(nonen ? [nonen] : []), ...(objIsArray ? [] : [val]), obj[val]];
                // Don't push if the array contains the array index
                typeof obj[val] !== 'number' && arr.push(classArr.join('-'));
            }
        });
        return arr.join(' ');
    };
    const makeClass = (input, propName, classPrefix) => {
        const inputType = typeof input;
        if (inputType === 'string') {
            return `${classPrefix}-${propName}-${input}`;
        }
        if (inputType === 'boolean') {
            return `${classPrefix}-${propName}`;
        }
        return makeRecursiveClass(input, propName, classPrefix);
    };
    const wrapperStyle = {
        ...firstChildStyle,
        ...style,
    };
    const baseClass = 'uitk-spacing';
    const wrapperClassNames = getClassNameList$1([
        baseClass,
        firstChildClassName,
        margin && `${makeClass(margin, 'margin', baseClass)}`,
        padding && `${makeClass(padding, 'padding', baseClass)}`,
        border && `${makeClass(border, 'border', baseClass)}`,
        className,
    ]);
    const decoratedChild = React.cloneElement(firstChild, {
        className: wrapperClassNames,
        ...(stid && { 'data-stid': stid }),
        ...(Object.keys(wrapperStyle).length && {
            style: wrapperStyle,
        }),
    });
    return decoratedChild;
};
EGDSSpacing.displayName = 'EGDSSpacing';

const getClassNameList = classNames.bind(styles);
const EGDSSpacingHr = (props) => {
    const { blockMargin = 'four' } = props;
    const baseClass = 'uitk-spacing-hr';
    return (jsx(EGDSSpacing, { border: ['blockstart'], className: getClassNameList(baseClass), margin: { block: blockMargin }, children: jsx("hr", {}) }));
};

export { EGDSSpacingBorders as E, EGDSSpacingSpaces as a, EGDSSpacing as b, EGDSSpacingHr as c };
//# sourceMappingURL=index-chunk.esm.js.map
